// Globals (yay)
require("./vendor-globals")

// CSS
require("@pathwright/ux/src/components/chakra/chakra-reset.css")
require("global/views/styles/typography.css")
require("global/views/styles/core.css")
require("global/views/styles/app.css")
require("global/views/styles/bootstrap-overrides.css")
